import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function useUrlParam(key, defaultValue, validator) {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawValue = searchParams.get(key);
  const isValid = rawValue !== null && (!validator || validator(rawValue));
  const value = isValid ? rawValue : defaultValue;

  useEffect(() => {
    if (rawValue === value || (rawValue == null && (value == null || value === ''))) return;

    setSearchParams((currentParams) => {
      const nextParams = new URLSearchParams(currentParams);
      if (value == null || value === '') {
        nextParams.delete(key);
      } else {
        nextParams.set(key, value);
      }
      return nextParams;
    }, { replace: true });
  }, [key, rawValue, setSearchParams, value]);

  const setValue = (nextValue) => {
    const resolvedValue = typeof nextValue === 'function' ? nextValue(value) : nextValue;

    setSearchParams((currentParams) => {
      const nextParams = new URLSearchParams(currentParams);
      if (resolvedValue == null || resolvedValue === '') {
        nextParams.delete(key);
      } else {
        nextParams.set(key, resolvedValue);
      }
      return nextParams;
    }, { replace: true });
  };

  return [value, setValue];
}
